import {StepByStep} from './dsl/stepByStep';
import {InternetListManager} from './dsl/internetListManager';
import {InternetDetailManager} from './dsl/internetDetailManager';
import {InternetAddressCompleter} from './dsl/internetAddressCompleter';
import {InternetAddressLayer} from './dsl/internetAdressLayer';

const viewrootDetail = document.querySelector<HTMLElement>('.dsl.detail .dsl-tarif-detail');
if (viewrootDetail) {
    new StepByStep(viewrootDetail);
    new InternetDetailManager(viewrootDetail);
    new InternetAddressCompleter(viewrootDetail);
    new InternetAddressLayer(viewrootDetail);
}

export class Dsllistloader {
    constructor(viewRoot: HTMLElement) {
        new InternetListManager(viewRoot);
        new InternetAddressCompleter(viewRoot);
        new InternetAddressLayer(viewRoot);
    }
}
// wird benoetigt um in views die klasse zu laden
if (typeof window !== 'undefined') {
    (window as any)['Dsllist'] = Dsllistloader;
}
